import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderFearlessFamilyDevotional from "../../../../src/content/fearless-family-devotional/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderFearlessFamilyDevotional,
  React
};